export default __webpack_public_path__ + "static/media/1539013345138.5fb684ae.jpg";